import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import api, { formatApiError } from "../api";
import { useApp } from "../context/AppContext";
import { Seo } from "../components/Seo";
import { Button } from "../components/ui/button";

export default function Login() {
  const { login } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      login(data);
      const next = location.state?.next || (["operator", "manager", "admin", "super_admin"].includes(data.role) ? "/admin" : "/dashboard");
      navigate(next);
    } catch (err) { setError(formatApiError(err)); } finally { setLoading(false); }
  };

  const input = "w-full h-12 rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring";

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="login-page">
      <Seo title="Login" description="Login to your DocGalaxy account." />
      <div className="bg-white border border-border rounded-2xl p-8 shadow-sm">
        <h1 className="font-display font-bold text-2xl">Welcome back</h1>
        <p className="text-sm text-muted-foreground mt-1">Login to track orders and documents.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-semibold" htmlFor="login-email">Email</label>
            <input id="login-email" type="email" required className={input} value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs font-semibold" htmlFor="login-password">Password</label>
            <input id="login-password" type="password" required className={input} value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full h-12 bg-primary" disabled={loading} data-testid="login-submit-btn">
            {loading ? "Signing in..." : "Login"}
          </Button>
        </form>
        <div className="mt-4 flex justify-between text-sm">
          <Link to="/forgot-password" className="text-primary hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
          <Link to="/register" className="text-secondary font-semibold hover:underline" data-testid="register-link">Create account</Link>
        </div>
      </div>
    </div>
  );
}
